import React from 'react';
import PropTypes from 'prop-types';
import {
    ExpansionPanel, Card, CardHeader,
    CardContent, Table, TableBody,
    TableRow, TableCell, ExpansionPanelSummary,
    Typography, ExpansionPanelDetails,
    List, ListItem, ListItemText
} from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import IconError from '@material-ui/icons/ErrorOutline';
import IconOK from '@material-ui/icons/CheckCircleOutline';


export class ExportResult extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
        };
    }
    getDateTime(datstr) {
        if (datstr === null) return '';
        var dat = new Date(datstr);
        var yyyy = dat.getFullYear();
        var mm = dat.getMonth() < 9 ? "0" + (dat.getMonth() + 1) : (dat.getMonth() + 1); // getMonth() is zero-based
        var dd = dat.getDate() < 10 ? "0" + dat.getDate() : dat.getDate();
        var hh = dat.getHours() < 10 ? "0" + dat.getHours() : dat.getHours();
        var min = dat.getMinutes() < 10 ? "0" + dat.getMinutes() : dat.getMinutes();
        var ss = dat.getSeconds() < 10 ? "0" + dat.getSeconds() : dat.getSeconds();
        return "" + dd + "." + mm + "." + yyyy + " " + hh + ":" + min + ":" + ss;
    };

    render() {
        var { resData } = this.props;
        const errors = (resData.errors.map(err => <ExpansionPanel key={err.id}>
            <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
                <Typography variant='subtitle2'>{err.errorIdentity}</Typography>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails>
                <List disablePadding>
                    {err.errorDetails.map(detail =>
                        <ListItem key={detail.id}>
                            <ListItemText primary={detail.errorDesc} />
                        </ListItem>)}
                </List>
            </ExpansionPanelDetails>
        </ExpansionPanel>));

        return <Card>
            <CardHeader title={
                <Typography variant='h6'>{resData.resultSummary}</Typography>
            } avatar={resData.importSuccessfull ? <IconOK /> : <IconError />} />
            <CardContent>

                <Table>
                    <TableBody>
                        <TableRow>
                            <TableCell align="right" variant='head'>Čas odovzdania</TableCell>
                            <TableCell>{this.getDateTime(resData.timestamp)}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" variant='head'>Názov súboru</TableCell>
                            <TableCell>{resData.fileName}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align="right" variant='head'>Obdobie</TableCell>
                            <TableCell>{resData.month}/{resData.year}</TableCell>
                        </TableRow>
                        {resData.errors != null && resData.errors.length > 0 &&
                            <TableRow>
                                <TableCell align="right" variant='head'  >Chyby súboru</TableCell>
                                <TableCell>{resData.errorCount}</TableCell>
                            </TableRow>
                        }
                        {resData.errors != null && resData.errors.length > 0 &&
                            <TableRow>
                                <TableCell/>
                                <TableCell>{errors}</TableCell>
                            </TableRow>}
                    </TableBody>
                </Table>
            </CardContent>
        </Card>
    }

}

ExportResult.propTypes = {
    resData: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/insem/ExportResult.jsx